import React, { Component } from 'react';
import Button from '../elements/editors/mui/Button';
import { CircularProgress } from '@mui/material';
import './TokenView.scss';
import { ROUTE_DASHBOARD } from '../../constants/pathnames';
import RoutePrefixContext from '../../../new/contexts/RoutePrefixContext';
import { TokenContent } from 'js/components/token/TokenContent';

const styles = {
  overlayBody: {
    border: 'none',
  },
  copyButtonStyleDefault: {
    width: '100%',
    lineHeight: '38px',
    height: 'auto',
    margin: 0,
    border: 4,
    opacity: 1,
    minWidth: 'unset',
  },
  copyButtonStyleCopied: {
    width: '100%',
    lineHeight: '38px',
    height: 'auto',
    margin: 0,
    border: 4,
    opacity: 0.8,
    minWidth: 'unset',
  },
  buttonStyle: {
    width: 'auto',
    minWidth: 150,
    lineHeight: '38px',
    height: 'auto',
    marginRight: 0,
    marginLeft: 0,
    border: 4,
    padding: 0,
  },
};

class TokenView extends Component {
  static contextType = RoutePrefixContext;

  _logout = () => {
    this.props.logout();
  };

  _routeDashboard = () => {
    const { history } = this.props;
    history.push(`${this.context}${ROUTE_DASHBOARD}`);
  };

  render() {
    const { onlyContent } = this.props;

    if (onlyContent) {
      return <TokenContent {...this.props} />;
    }

    return (
      <div className="overlay-container">
        <div className="overlay-body" style={styles.overlayBody}>
          <div className="token-page">
            {this.props.isLoading && (
              <div className="loading-background">
                <CircularProgress color="secondary" />
              </div>
            )}
            <div className="logo" style={{ marginBottom: 33 }} />
            <TokenContent {...this.props} />
            <div className="token-page-actions">
              <Button buttonTheme="brand" rootStyle={styles.buttonStyle} onClick={this._logout}>
                Logout
              </Button>
              <Button
                buttonTheme="primary"
                rootStyle={styles.buttonStyle}
                onClick={this._routeDashboard}
              >
                View Dashboard
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TokenView.defaultProps = {
  showCLIDownload: false,
};

export default TokenView;
